
/* IMPORT */

import Item from './item';

/* GROUP */

class Group extends Item {

  contextValue = 'group';

}

/* EXPORT */

export default Group;
